import styled from "styled-components";

export const Container = styled.div<{ background: string }>`
  display: flex;
  flex-direction: column;
  width: 960px;
  max-width: 96vw;
  height: 90vh;
  max-height: 90vh;
  border-radius: 12px;
  background: ${(props) => props.background};
  overflow: hidden;
  position: relative;
`;

export const CloseButton = styled.div<{ color: string; hoverBackground: string }>`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  color: ${(props) => props.color};
  transition: background 0.2s;

  &:hover {
    background: ${(props) => props.hoverBackground};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: stretch;
  overflow: auto;
  min-height: 0;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div<{ background: string; border: string }>`
  display: flex;
  flex-direction: column;
  width: 34%;
  min-width: 280px;
  padding: 28px 22px 22px 22px;
  background: ${(props) => props.background};
  border-right: 1px solid ${(props) => props.border};
  align-self: stretch;

  @media (max-width: 820px) {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid ${(props) => props.border};
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 28px 24px 0 24px;
  gap: 14px;
  min-width: 0;
  min-height: 0;
`;

export const BadgeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const Badge = styled.div<{ background: string; color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const MegaphoneWrapper = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color};
`;

export const LeftTitle = styled.h2<{ color: string }>`
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  color: ${(props) => props.color};
  margin: 0 0 12px 0;
`;

export const TitleAccent = styled.span<{ color: string }>`
  color: ${(props) => props.color};
`;

export const LeftDescription = styled.p<{ color: string }>`
  font-size: 13px;
  line-height: 1.5;
  color: ${(props) => props.color};
  margin: 0 0 20px 0;
`;

export const BenefitList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1;
`;

export const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`;

export const BenefitIcon = styled.div<{ background: string; color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
`;

export const BenefitText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BenefitTitle = styled.span<{ color: string }>`
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.color};
`;

export const BenefitDescription = styled.span<{ color: string }>`
  font-size: 12px;
  line-height: 1.4;
  color: ${(props) => props.color};
`;

export const Callout = styled.div<{ background: string; border: string }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  margin-top: 18px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${(props) => props.background};
  border: 1px solid ${(props) => props.border};
`;

export const CalloutText = styled.span<{ color: string }>`
  font-size: 12px;
  line-height: 1.45;
  color: ${(props) => props.color};
`;

export const RightIntro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  gap: 10px;
  width: 100%;
  padding: 12px 28px 16px 0;
`;

export const RightIntroText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const RightIntroTitle = styled.span<{ color: string }>`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: ${(props) => props.color};
`;

export const RightIntroSubtitle = styled.span<{ color: string }>`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: ${(props) => props.color};
`;

export const FeatureCard = styled.div<{ border: string; background: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-height: 0;
  gap: 14px;
  padding: 18px 16px;
  border-radius: 12px;
  border: 1.5px solid ${(props) => props.border};
  background: ${(props) => props.background};

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
    flex: none;
  }
`;

export const FeatureCardFixed = styled(FeatureCard)`
  flex: none;
  height: 250px;
  min-height: 250px;
  max-height: 250px;
  width: 100%;

  @media (max-width: 700px) {
    height: auto;
    min-height: unset;
    max-height: unset;
  }
`;

export const FeatureCardCenter = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 0;
  width: 100%;
`;

export const FeatureImage = styled.img`
  width: 110px;
  height: 120px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  min-width: 0;
`;

export const FeatureTitle = styled.span<{ color: string }>`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.color};
`;

export const FeatureSubtitle = styled.span<{ color: string }>`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color};
  margin-bottom: 4px;
`;

export const Checklist = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CheckItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const CheckText = styled.span<{ color: string }>`
  font-size: 12px;
  color: ${(props) => props.color};
`;

export const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  min-width: 150px;
  flex-shrink: 0;

  @media (max-width: 700px) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const PriceLabel = styled.span<{ color: string }>`
  font-size: 11px;
  color: ${(props) => props.color};
  text-align: right;

  @media (max-width: 700px) {
    text-align: left;
  }
`;

export const PriceValue = styled.span<{ color: string }>`
  font-size: 30px;
  font-weight: 700;
  color: ${(props) => props.color};
  line-height: 1;
`;

export const PricePeriod = styled.span<{ color: string }>`
  font-size: 11px;
  color: ${(props) => props.color};
`;

export const PriceNote = styled.div<{ background: string; color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

export const InvestmentCallout = styled.div<{ background: string; border: string }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${(props) => props.background};
  border: 1px solid ${(props) => props.border};
`;

export const InvestmentCalloutPinned = styled(InvestmentCallout)`
  margin-top: auto;
`;

export const InvestmentText = styled.span<{ color: string }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  line-height: 1.45;
  color: ${(props) => props.color};
`;

export const InvestmentBold = styled.span<{ color: string }>`
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  color: ${(props) => props.color};
`;

export const Footer = styled.div<{ background: string; border: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 10px;
  padding: 14px 0 16px 0;
  background: ${(props) => props.background};
  border-top: 1px solid ${(props) => props.border};
`;

export const ButtonSecondary = styled.button<{ color: string; border: string; hoverBackground: string }>`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.color};
  background: transparent;
  border: 1px solid ${(props) => props.border};
  border-radius: 6px;
  padding: 9px 18px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: ${(props) => props.hoverBackground};
  }
`;

export const ButtonPrimary = styled.button<{ background: string; color: string }>`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  border: none;
  border-radius: 6px;
  padding: 9px 20px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const ReleasesContainer = styled.div<{ background: string }>`
  display: flex;
  width: 580px;
  flex: 1;
  flex-direction: column;
  border-radius: 7px;
  background: ${(props) => props.background};
  overflow: hidden;
`;

export const IconWrapper = styled.div<{ background: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${(props) => props.background};
  margin: 0 auto 14px auto;
`;

export const HeaderContent = styled.div<{ background: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px 16px 24px;
  background: ${(props) => props.background};
  position: relative;
`;

export const Title = styled.h2<{ color: string }>`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: ${(props) => props.color};
  margin: 0 0 6px 0;
`;

export const Subtitle = styled.p<{ color: string }>`
  font-size: 13px;
  text-align: center;
  color: ${(props) => props.color};
  margin: 0;
`;

export const ReleaseList = styled.div<{ background: string }>`
  display: flex;
  flex-direction: column;
  padding: 12px 24px 4px 24px;
  background: ${(props) => props.background};
`;

export const ReleaseRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 0;
`;

export const Bullet = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.color};
  margin-top: 5px;
  flex-shrink: 0;
`;

export const ReleaseTextContainer = styled.div`
  margin-left: 12px;
  flex: 1;
  line-height: 1.5;
`;

export const ReleaseTitle = styled.span<{ color: string }>`
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.color};
`;

export const ReleaseSeparator = styled.span<{ color: string }>`
  font-size: 13px;
  color: ${(props) => props.color};
  margin: 0 5px;
`;

export const ReleaseDescription = styled.span<{ color: string }>`
  font-size: 13px;
  color: ${(props) => props.color};
`;

export const MoreText = styled.span<{ color: string }>`
  font-size: 13px;
  font-style: italic;
  color: ${(props) => props.color};
  margin: 20px 0 12px 20px;
  font-weight: bold;
`;

export const ReleasesFooter = styled.div<{ background: string; border: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: ${(props) => props.background};
  border-top: 1px solid ${(props) => props.border};
`;

export const LinkText = styled.a<{ color: string }>`
  font-size: 13px;
  color: ${(props) => props.color};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.color};
    opacity: 0.8;
  }
`;

export const ButtonConfirm = styled.button<{ background: string }>`
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: ${(props) => props.background};
  border: none;
  border-radius: 5px;
  padding: 8px 20px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;
